<template>
    <ul class="timeline timeline-alt" :class="{'timeline-centered': centered}" v-if="logs && logs.length">
        <li class="timeline-event" v-for="log in logs">
            <div class="timeline-event-icon bg-info">
                <i class="fa fa-info-circle"></i>
            </div>
            <div class="timeline-event-block block js-appear-enabled animated fadeIn" data-toggle="appear">
                <div class="block-header block-header-default">
                    <h3 class="block-title">Change</h3>
                    <div class="block-options">
                        <div class="timeline-event-time block-options-item font-size-sm font-w600">
                            {{Bandwango.dateToLocal(log.created_at)}}
                        </div>
                    </div>
                </div>
                <div class="block-content">
                    <div class="media font-size-sm">
                        <!-- <a class="img-link mr-2" href="javascript:void(0)">
                            <img class="img-avatar img-avatar48 img-avatar-thumb" src="assets/media/avatars/avatar6.jpg" alt="">
                        </a> -->
                        <div class="media-body overflow-auto">
                            <p>
                                {{log.message}}
                            </p>
                            <div class="p-3">
<!--                                <pre>{{ log.data | pretty }}</pre>-->
                                <div v-html="log.formattedData"></div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
    <div v-else>
        <h3>No Logs</h3>
    </div>
</template>

<script>
    export default {
        props: {
			assignment: {
				type: String|Number,
				required: true
			},
			assignmentId: {
				type: String|Number,
				required: true
			},
            centered: {
			    type: Boolean,
                default: true,
            }
        },
        data:() => {
			return {
                logs: [],
				page: 1,
				display: 20,
                users:[],
                statuses:[],
                dataMap: [
                    {key:'status', map:'statuses', link:'id', value:'name'},
                    {key:'contact_user_id', map:'users', link:'id', value:'name', newKey:'Contact User'},
                    {key:'last_called', format:'date'},
                ]
			}
		},

        methods: {

            getUsers() {
                // Should the frontend be doing this?
                const self = this;
                if (self.assignment === 'venue') {
									axios.get('/users').then(response => {
											self.users = response.data;
											self.getStatuses();
									}).catch(e => {
									});
								} else {
                	self.getStatuses();
								}
            },
            getStatuses() {
                // TODO:: can we limit this based on this.assignment?
                const self = this;
                axios.get('/status').then(response => {
                    self.statuses = response.data;
                    self.getLogs();
                }).catch(e => {
                });
            },
            getLogs() {
                if( !this.assignmentId ) return;
                // TODO:: query pages as user scrolls down the page
                const self = this;
                axios.get('/logs', {
                    params: {
                        assignment: this.assignment,
                        assignment_id: this.assignmentId,
                    }
                }).then(response => {
                    self.logs.push(...response.data.data.map(x => self.formatLog(x)));
                }).catch(e => {
                });
			},
			formatLog(log) {
                if (log.data) {
                  log.formattedData = '<ul>';
                  const data = JSON.parse(log.data);
                  if (!data) {
                    return log;
                  }
                  Object.keys(data).forEach((key) => {
                    if(data[key]) {
                      let map = this.dataMap.find((x) => x.key === key);
                      let oldValue, newValue;
                      if( data[key].oldValue || data[key].newValue ) {
                          oldValue = _.isObject(data[key].oldValue) ? '<pre>' + JSON.stringify(data[key].oldValue, undefined, 2) + '</pre>' : data[key].oldValue;
                          newValue = _.isObject(data[key].newValue) ? '<pre>' + JSON.stringify(data[key].newValue, undefined, 2) + '</pre>' : data[key].newValue;
                      } else {
                          newValue = _.isObject(data[key]) ? '<pre>' + JSON.stringify(data[key], undefined, 2) + '</pre>' : data[key];
                      }
                      if (map) {
                        if (map.map) {
                          let fOld = this[map.map].find((x) => x[map.link] == oldValue);
                          let fNew = this[map.map].find((x) => x[map.link] == newValue);
                          oldValue = fOld && fOld[map.value] || oldValue;
                          newValue = fNew && fNew[map.value] || newValue;
                        }

                        if (map.format) {
                          switch (map.format) {
                            case 'date':
                              oldValue = oldValue != '0000-00-00 00:00:00' ? Bandwango.dateToLocal(oldValue) : oldValue;
                              newValue = newValue != '0000-00-00 00:00:00' ? Bandwango.dateToLocal(newValue) : newValue;
                              break;
                          }
                        }
                      }

                      if (oldValue === undefined && newValue === undefined) return true; // no need to show the change
                      if (oldValue && newValue === undefined)
                        newValue = "''";

                      log.formattedData += '<li>' + Bandwango.prettyId(map && map.newKey || key) + ' was ' + (oldValue ? 'changed from <b/>' + oldValue + '</b>' : 'set') + ' to <b>' + newValue + '</b>.</li>';
                    }
                  });
                  log.formattedData += '</ul>';
                }
                if( log.userName && !log.message.includes(log.userName) )
                    log.message = log.userName+' made a modification: '+log.message;

                return log;
            }
        },
        mounted() {
			this.getUsers();
        },
        watch: {
            assignmentId(newValue, oldValue) {
                // if( !oldValue )
                    this.getLogs();
            },
        }
    }
</script>
